@let templateGroupsLabel = 'MANAGEMENT.COMMUNICATION-CENTER.TEMPLATE-GROUPS' | translate;

<topo-dialog
  [dialogRef]="dialogRef"
  [title]="templateGroupsLabel"
  showHeaderBorder>
  @let foo = state.checkIfNameIsUnique;
  <div class="dialog-content">
    @let templateGroups = state.templateGroups();

    <div class="input-container">
      <topo-template-group-crud-input
        [state]="state"
        (onSubmit)="createTemplateGroup($event)"
        (valueChanged)="searchTerm.set($event)" />

      @if (templateGroups.length) {
        <label class="paddingless mt-5">{{ templateGroupsLabel }}</label>
      }
    </div>

    @for (group of templateGroups; track group.uId) {
      <topo-template-group-crud-item
        [templateGroup]="group"
        (onEdit)="editTemplateGroup($event)"
        (onDelete)="deleteTemplateGroup($event)" />
    }
  </div>
</topo-dialog>
